import { Injectable } from '@angular/core';

import { Action, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';

import { HttpApiService } from '../../../core/http-api.service';
import { MarkFeatureAsDiscovered } from './feature-discovery.actions';

@State({
  name: 'featureDiscovery',
})
@Injectable()
export class ReferralsFeatureDiscoveryRepo {
  constructor(private httpApi: HttpApiService) {}

  @Action(MarkFeatureAsDiscovered)
  private markFeatureAsDiscovered(
    ctx: StateContext<any>,
    action: MarkFeatureAsDiscovered,
  ): Observable<any> {
    return this.httpApi.patch('/feature_discovery', null, { featureDiscovery: action.payload });
  }
}
